import { Box, Grid, Typography } from '@mui/material'
import { useContext } from 'react'
import { ApplicationContext } from '../App'
export const Home: React.FC = () => {
    const { identities } = useContext(ApplicationContext)
    const ownOrg = identities.find((entry) => entry.self)
    const orgName = ownOrg?.displayName ?? 'loading..'
    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: '80vh' }}
        >
            <Grid item xs={3}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h3">👋 Welcome to Rhiza Health</Typography>
                    <Typography variant="body1">You are currently logged into {orgName}</Typography>
                </Box>
            </Grid>
        </Grid>
    )
}
